import { render, staticRenderFns } from "./UploadMerchant.vue?vue&type=template&id=272a433e"
import script from "./UploadMerchant.vue?vue&type=script&lang=js"
export * from "./UploadMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports